import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function forbiddenInputsValidator(blacklist: string[]): ValidatorFn {
  blacklist = blacklist || [];

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    for (const token of blacklist) {
      const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const tokenAsRegex = new RegExp(escapedToken, 'i');
      const isForbidden = tokenAsRegex.test(control.value.trim());
      if (isForbidden) {
        return { forbiddenInput: { value: control.value } };
      }
    }
    
    return null;
  };
}
